import routes from './routes';
import { SetRoutes } from 'components';

const InvoicesCompareFootfallSalesPages = () => {
  return (
    <>
      <SetRoutes routes={routes} />
    </>
  );
};

export default InvoicesCompareFootfallSalesPages;
